export { default } from './CourseMap'



// WEBPACK FOOTER //
// ./src/modules/common/components/map/index.js